//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { mapMutations } from 'vuex';
export default {
	data() {
		return {
			termsText: '',
			policyText: '',
		};
	},
	computed: {
		termsAgree: {
			get() {
				return this.$store.state.auth.termsAgree;
			},
			set(value) {
				this.$store.commit('auth/SET_TERMS_AGREE', value);
			},
		},
		policyAgree: {
			get() {
				return this.$store.state.auth.policyAgree;
			},
			set(value) {
				this.$store.commit('auth/SET_POLICY_AGREE', value);
			},
		},
	},
	mounted() {
		this.termsData();
		this.privacyData();
	},
	methods: {
		...mapMutations('auth', ['SET_TERMS_AGREE', 'SET_POLICY_AGREE']),
		async termsData() {
			const { data } = await axios.get('/terms.txt');
			this.termsText = data;
		},
		async privacyData() {
			const { data } = await axios.get('/privacy.txt');
			this.policyText = data;
		},
		// checkTermsAgree() {
		// 	this.SET_TERMS_AGREE();
		// 	console.log('check value ?', this.isTermsAgree);
		// },
		confirmAgree() {
			if (!this.termsAgree) {
				console.log('약관 동의안됬다.');
				this.$store.commit('app/SET_ALERT_DIALOG_VISIBLE', true);
				this.$store.commit('app/SET_ALERT_DIALOG_TITLE', '약관동의');
				this.$store.commit('app/SET_ALERT_DIALOG_CONTENTS', '쇼핑몰 약관 동의가 필요합니다!');
			}
			if (!this.policyAgree) {
				// console.log('개인정보 수집 동의 안됬다.');
				this.$store.commit('app/SET_ALERT_DIALOG_VISIBLE', true);
				this.$store.commit('app/SET_ALERT_DIALOG_TITLE', '개인정보수집동의서');
				this.$store.commit(
					'app/SET_ALERT_DIALOG_CONTENTS',
					'개인정보수집동의서가 동의가 필요합니다!',
				);
			}

			if (this.termsAgree && this.policyAgree) this.$store.commit('auth/SET_CONFIRM_AGREE', true);
		},
	},
};
